export const getFieldError = (fieldName: string, errors: any) => {
  const parts = fieldName.split('.');
  let error = errors;
  for (const part of parts) {
    error = error?.[part];
  }
  return error;
};

export const getFieldTouched = (fieldName: string, touched: any) => {
  const parts = fieldName.split('.');
  let touchedField = touched;
  for (const part of parts) {
    touchedField = touchedField?.[part];
  }
  return touchedField;
};
